module.exports = __webpack_public_path__ + "img/mobile scanner stand-03.febf9f10.png";